export async function request(path, method = 'GET', data) {
    const headers = {};
    if (method !== 'GET') {
        const tokenResponse = await fetch('/api/csrf', { cache: 'no-store', credentials: 'same-origin' });
        if (!tokenResponse.ok)
            throw new Error('The studio service is unavailable. Please try again.');
        const { csrfToken } = await tokenResponse.json();
        headers['x-csrf-token'] = csrfToken;
        if (data !== undefined)
            headers['Content-Type'] = 'application/json';
    }
    const response = await fetch(path, { method, headers, credentials: 'same-origin', cache: 'no-store', body: data === undefined ? undefined : JSON.stringify(data) });
    const payload = await response.json();
    if (!response.ok)
        throw new Error(payload.error || 'The studio service is unavailable. Please try again.');
    return payload;
}
